import Vue from 'vue'
import App from './App.vue'
import router from './router/router.js'
import './assets/style/resrt.css'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import api from './api/require.js'
import store from './store/index'

Vue.config.productionTip = false
Vue.prototype.$http = api.https
Vue.use(ElementUI);


new Vue({
	router,
	store,
	render: h => h(App),
}).$mount('#app')
